import LimitText from '@/modules/LimitText/LimitText.js';

const initCardNews = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="card-news"]'));
  elements.forEach((element) => {
    const desc = element.querySelector('[data-card-news="card-desc"]');
    const limitStr = LimitText(desc.textContent, 260);
    desc.textContent = limitStr;
  });
};
export default initCardNews;
